import { render, staticRenderFns } from "./ClientesForm.vue?vue&type=template&id=56056ab2&"
import script from "./ClientesForm.vue?vue&type=script&lang=js&"
export * from "./ClientesForm.vue?vue&type=script&lang=js&"
import style0 from "./ClientesForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports